module.exports = __webpack_public_path__ + "static/tjykdxzyy-6b0079f35d10b07102edd2c6da656e45.jpg";